// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerWithCaption_root__Kar7N","containImage":"BannerWithCaption_containImage__MO7qv","caption":"BannerWithCaption_caption__p52li"};